<template>
    <div>
        <div v-if="doorCheckLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

    <div v-if="doorCheckFound === false && doorCheckLoading === false">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">Sorry...</h2>
            </div>
        </div>
        <div class="widget">
            <div class="widget-body">
                <p>The door check could not be found. Please check the URL and try again.</p>
                <p> <router-link to="/">Return Home</router-link></p>
            </div>
        </div>
    </div>
    <div v-if="doorCheck">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">
                    <router-link to="/">
                        Door Inspection</router-link>
                    &raquo;
                    {{ doorCheck.document_id }} | {{ doorCheck.document_title }}        </h2>
            </div>
            <div class="col-md-4">
                <router-link :to="{ name: 'door-check-edit', params: {id: doorCheck.site_door_check_id} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                    Edit Door Inspection
                </router-link>
            </div>
        </div>

        <div class="widget">
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                    <tr>
                        <td><strong>Document ID</strong></td>
                        <td>{{ doorCheck.document_id }}</td>
                    </tr>
                    <tr>
                        <td><strong>Document Title</strong></td>
                        <td>{{ doorCheck.document_title }}</td>
                    </tr>
                    <tr>
                        <td><strong>Client Site</strong></td>
                        <td>{{ doorCheck.client_site }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && doorCheck.use_bm_trada_template">
                        <td><strong>RMA Form Sequential Reference Number</strong></td>
                        <td>{{ doorCheck.rma_form_sequential_ref_no !== undefined ? doorCheck.rma_form_sequential_ref_no : '' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Date of Inspection</strong></td>
                        <td>{{ doorCheck.date_of_inspection | formatDate }}</td>
                    </tr>
                    <tr v-if="dbName === 'qfpc'">
                        <td><strong>Prepared by</strong></td>
                        <td>{{ doorCheck.prepared_by !== undefined ? doorCheck.prepared_by : '' }}</td>
                    </tr>
                    <tr v-if="dbName === 'qfpc'">
                        <td><strong>Edited by</strong></td>
                        <td>{{ doorCheck.edited_by !== undefined ? doorCheck.edited_by : '' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Location</strong></td>
                        <td>{{ doorCheck.location }}</td>
                    </tr>
                    <tr v-if="dbName === 'qfpc'">
                        <td><strong>Country</strong></td>
                        <td>{{ doorCheck.country !== undefined ? doorCheck.country : 'England' }}</td>
                    </tr>
                    <tr v-if="doorCheck.notes">
                        <td><strong>Notes</strong></td>
                        <td>
                            <p>{{ doorCheck.notes }}</p>
                            <hr>
                            <small v-if="doorCheck.include_notes_in_report"><em>These notes <strong>will</strong> be included in the report.</em></small>
                            <small v-else><em>These notes <strong>will not</strong> be included in the report.</em></small>

                        </td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                       <td><strong>Schedule of Client Provided Information</strong></td>
                       <td>
                            <ul v-if="doorCheck.client_provided_info_schedule">
                                <li v-for="(item, index) in doorCheck.client_provided_info_schedule" v-bind:key="'cpi-s-' + index">{{ item }}</li>
                            </ul>
                       </td> 
                    </tr>
                    <tr>
                        <td><strong>Disclaimer</strong></td>
                        <td>{{ doorCheck.disclaimer }}</td>
                    </tr>
                    <tr v-if="dbName !== 'jpfire'">
                       <td><strong>Is this being carried out under BM Trada?</strong></td>
                       <td>{{ doorCheck.use_bm_trada_template ? 'Yes' : 'No'  }}</td> 
                    </tr>
                    <tr v-if="dbName !== 'jpfire' && dbName !== 'qfpc'">
                       <td><strong>Is this Third Party Report?</strong></td>
                       <td>{{ doorCheck.is_third_party_report ? 'Yes' : 'No'  }}</td> 
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row" v-if="dbName !== 'jpfire'">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Site Plans</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row pb-3">
                            <div class="col-md-12 mt-3">
                                <table class="table table-condensed table-bordered" v-if="doorCheckSitePlans && doorCheckSitePlans.length > 0">
                                    <fdr-site-plan-line
                                            v-for="item in doorCheckSitePlans"
                                            v-bind:key="item.site_door_check_site_plan_id"
                                            v-bind:item="item"
                                            @site-plan-removed="removeSitePlan"
                                    ></fdr-site-plan-line>
                                </table>
                                <p class="text-center" v-else>There are no site plans attached to this report.</p>
                            </div>
                        </div>
                        <router-link :to="{ name: 'door-check-add-site-plan', params: {id: doorCheck.site_door_check_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                            Add Site Plan
                        </router-link>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>
                            Doors                </h3>
                    </div>
                    <div class="widget-body">
                        <div class="input-group pb-5">
                            <span class="input-group-addon pr-0 pl-0">
                                <a class="btn" href="#">
                                    <i class="fa fa-search"></i>
                                </a>
                            </span>
                            <input type="text" class="form-control dynamic-search" name="search_term"
                                   v-model="search"
                                   placeholder="Search (enter at least 3 characters)">
                        </div>

                        <div class="row pb-3">
                            <div class="col-md-12 mt-3">
                                <table class="table table-condensed table-bordered" v-if="filteredDoorCheckDoors && filteredDoorCheckDoors.length > 0">
                                    <door-check-door-line
                                            v-for="door_check_door in filteredDoorCheckDoors"
                                            v-bind:key="door_check_door.id"
                                            v-bind:door_check_door="door_check_door"
                                    ></door-check-door-line>
                                </table>
                                <p class="text-center" v-else>There are no doors attached to this inspection.</p>
                            </div>
                        </div>
                        <router-link :to="{ name: 'door-check-add-door', params: {id: doorCheck.site_door_check_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                            Add Another Door
                        </router-link>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import DoorCheckDoorLine from '@/components/DoorCheckDoorLine.vue';
    import FdrSitePlanLine from '@/components/FdrSitePlanLine.vue';

    export default {
        components: {
            DoorCheckDoorLine,
            FdrSitePlanLine
        },
        data() {
            return {
                search: '',
                doorCheckFound: false,
                doorCheckLoading: true,
                retryDoorCheckCount: 0,
                retryDoorCheckDoorsCount: 0,
                doorCheck: null,
                doorCheckSitePlans: [],
                doorCheckDoors: [],
            }
        },
        methods: {
            getDoorCheck() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var doorCheckId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        var storeRequest = objectStore.get(doorCheckId);


                        storeRequest.onsuccess = function(event) {
                            vm.doorCheck = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.doorCheckFound = true;
                            }
                            vm.doorCheckLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.doorCheckFound = false;
                            vm.doorCheckLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getReportSitePlans() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    vm.doorCheckSitePlans = [];
                    
                    try {
                        var doorCheckId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_check_site_plans').objectStore('door_check_site_plans');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (
                                        vm.doorCheckSitePlans && doorCheckId == cursor.value.site_door_check_id
                                        && (cursor.value.is_deleted === false || cursor.value.is_deleted === undefined)
                                    ) {
                                        vm.doorCheckSitePlans.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getDoorCheckDoors() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.doorCheckDoors = [];
                    try {
                        var objectStore = db.transaction('door_check_doors').objectStore('door_check_doors');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.doorCheckDoors) {
                                        vm.doorCheckDoors.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })

            },
            removeSitePlan(site_plan_id) {
                let sitePlanIndex = this.doorCheckSitePlans.findIndex(i => i.site_door_check_site_plan_id == site_plan_id);
                if(sitePlanIndex >= 0) {
                    this.doorCheckSitePlans.splice(sitePlanIndex, 1);
                }
            }
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getDoorCheck();
            this.getReportSitePlans();
            this.getDoorCheckDoors();
        },
        computed: {
            filteredDoorCheckDoors() {
                var correctDoorCheckDoors = [];
                var vm = this;
                this.doorCheckDoors.forEach(function(entry) {
                    if (entry.site_door_check_id === vm.doorCheck.site_door_check_id &&
                        (entry.is_deleted === false || entry.is_deleted === undefined))
                    {
                        correctDoorCheckDoors.push(entry);
                    }
                });
                return correctDoorCheckDoors.filter(door => {
                    return (door.door_id && door.door_id.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                        || (door.barcode && door.barcode.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                });
            },
        }
    }
</script>